import { createFileRoute } from "@tanstack/react-router";
import { safeJsonLd } from "@/lib/structured-data";
import { bookingPageCrumbs, getClinicStructuredData } from "@/lib/structured-data/clinic";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { AcuityEmbed } from "@/components/site/AcuityEmbed";
import { AcuityConversionListener } from "@/components/site/AcuityConversionListener";

export const Route = createFileRoute("/schedule-a-consult/manhattan")({
  head: () => ({
    meta: [
      // Indexable since 3 Oct 2026, as on the old production site (Wayback
      // 2025 shows "index, follow"). The sitemap lists this page.
      // Title and meta: the WordPress copy (staging, 6 Oct 2026), title cut to
      // 60 characters. H1 names the procedure and the city (rule from Anthony).
      { title: "FREE Hair Transplant Consultation in Manhattan, NY | RESTORE" },
      {
        name: "description",
        content:
          "Schedule your free consultation with RESTORE in Manhattan, New York. You can do it in person or virtually. Our client advisors will answer your questions.",
      },
      {
        property: "og:title",
        content: "FREE Hair Transplant Consultation in Manhattan, NY | RESTORE",
      },
      {
        property: "og:description",
        content:
          "Book a free in-person or virtual hair restoration consultation with RESTORE in Manhattan, New York.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary" },
    ],
    links: [
      {
        rel: "canonical",
        href: "https://restorehair.com/schedule-a-consult/manhattan/",
      },
    ],
    scripts: [
      {
        type: "application/ld+json",
        children: safeJsonLd({
          "@graph": getClinicStructuredData("new-york", bookingPageCrumbs("Manhattan", "/schedule-a-consult/manhattan/")),
        }),
      },
    ],
  }),
  component: ScheduleManhattanPage,
});

function ScheduleManhattanPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main className="mx-auto max-w-5xl px-4 py-10 md:py-14">
        <h1 className="text-center text-3xl font-normal text-foreground md:text-5xl">
          Schedule Your <strong className="font-extrabold">FREE</strong> Hair Transplant Consultation in Manhattan, NY
        </h1>
        <p className="mt-4 text-center text-base text-muted-foreground md:text-lg">
          Select a time for a free hair transplant consultation in Manhattan.
        </p>
        <AcuityConversionListener />
        <div className="mt-8">
          <AcuityEmbed src="https://app.acuityscheduling.com/schedule.php?owner=24213130&owner=24213130&appointmentType=49646097" />
        </div>
        {/* WordPress copy under the booking widget (staging, 6 Oct 2026). The
            widget stays first, so it stays above the fold on mobile. */}
        <section className="mx-auto mt-12 max-w-3xl bg-muted px-6 py-10 text-center">
          <h4 className="text-2xl font-extrabold leading-tight text-foreground md:text-3xl">
            Great News! We Are Offering Virtual Consultations in Your Area
          </h4>
          <h5 className="mt-3 text-lg font-bold text-foreground">Schedule Your Complimentary Consultation</h5>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground">
            From the comfort of your home, we will explain how the procedure works and create a customized treatment
            tailored for your specific needs.
          </p>
          <a
            href="/schedule-a-consult/virtual/"
            className="mt-6 inline-block bg-primary px-8 py-4 text-sm font-bold tracking-wider text-primary-foreground transition hover:bg-primary/90"
          >
            Schedule Now
          </a>
        </section>
      </main>
      <Footer />
    </div>
  );
}